module.exports = __webpack_public_path__ + "media/components/assets/img/icons/calendar-3207fe1bf75b1994b0315eb6e8edbd6e.svg";